module.exports = __webpack_public_path__ + "static/media/Gabi-profil3.8db9aa69.JPG";